export interface IM82FindDealerMapBlockViewModel {
    locations?: IFindDealerMapLocation[] | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    markerIcon?: string | undefined;
    selectedMarkerIcon?: string | undefined;
}
export interface IFindDealerMapLocation {
    id: string;
    type?: string | undefined;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    web?: string | undefined;
    lat: number;
    lng: number;
    country?: string | undefined;
}

export type StoreOpeningHour = {
    day: string;
    opens: string | null;
    closes: string | null;
    isClosed: boolean;
};

export type StoreSchemaObject = {
    id?: string;
    _id?: string;
    hidden?: boolean;

    name?: string;

    latitude?: number;
    longitude?: number;
    lat?: number;
    lng?: number;

    addressLine1?: string;
    address1?: string;
    addressLine2?: string;
    address2?: string;

    zip?: string;
    postalCode?: string;
    city?: string;
    countryCode?: string;

    phone?: string;
    email?: string;

    url?: string;
    description?: string;
    image?: string;

    _type?: string;

    carrierCode?: 'GLS' | 'POSTNORD' | 'DAO';

    c_openingHours?: StoreOpeningHour[];

    c_openingStatusToday?: {
        day: string;
        isClosedToday: boolean;
        isClosedTodayMessage: string | null;
    };

    c_storeClosed?: boolean;
    c_storeClosedReason?: string;

    c_clickCollectFlag?: boolean;
    c_clickCollectFreeCapacityFlag?: boolean;
    c_clickCollectMaxPackages?: number;
    c_clickCollectEnabled?: boolean;

    c_clickReserveFlag?: boolean;
    c_clickReserveFreeCapacityFlag?: boolean;
    c_clickReserveEnabled?: boolean;

    c_readyForPublish?: boolean;

    c_weight?: number;
    c_storeIP?: string;

    'data-testid'?: string;
};

export type MapMarker = google.maps.LatLngLiteral & {
    id?: string;
    _id?: string; // used internal for markers without id
    hidden?: boolean;
    name?: string;
    latitude?: number;
    longitude?: number;
    addressLine1?: string;
    address1?: string;
    addressLine2?: string;
    address2?: string;
    zip?: string;
    city?: string;
    _type?: string;
    carrierCode: 'GLS' | 'POSTNORD' | 'DAO';
    postalCode?: string;
    c_openingHours?: [];
    'data-testid'?: string;
    c_storeClosedReason?: string;
    c_openingStatusToday?: { day: string; isClosedToday: boolean; isClosedTodayMessage: string };
};

export enum MapZoom {
    COUNTRY_VIEW = 7,
    STORE_VIEW = 15,
}
